import { compose, withStateHandlers } from 'recompose'
import CardSFC from './featuredMediaCardItem.sfc'
import { ICardItem, ICardItemSFC } from './types'

const enhancer = compose<ICardItemSFC, ICardItem>(
  withStateHandlers(() => ({ collapsed: false }), {
    toggleCollapsed: ({ collapsed }) => () => ({ collapsed: !collapsed }),
  })
)

export default enhancer(CardSFC)
